module.exports = __webpack_public_path__ + "img/lister.241e3a83.png";